export default __webpack_public_path__ + "static/media/cn-blue.b4e35b7d.png";